import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { Caution } from '@manulife/mux-cds-icons';
import { styles } from '../../../styles/input.styles';

export const InputLayout = ({ sx, error, showErrorText = true, children }) => {
  return (
    <Box sx={{ ...styles.container, ...sx }}>
      <Box sx={styles.input}>{children}</Box>
      {error && showErrorText && (
        <Typography sx={styles.error}>
          <Caution
            color="#A00E18"
            style={{ color: '#A00E18', fontSize: '16px' }}
          />
          {error}
        </Typography>
      )}
    </Box>
  );
};
